import { toODataString, State } from "@progress/kendo-data-query";
import { HttpClient } from "@angular/common/http";
import { switchMap } from "rxjs/operators";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { ODataResponse } from "../configuration/models/odata-response";
import { of, Observable } from "rxjs";
import { Identifiable } from "../configuration/models/identifiable";
import { AppConfigService } from './app-config.service';

export interface IDataService {
  delete(Id: number);
  get(state: State, queryUrl: string);
  update(dataItem: any, isNew: boolean);
}

export class DataService<T extends Identifiable> implements IDataService {
  private baseUrl: string;
  constructor(protected http: HttpClient, public resourceName: string, protected acs: AppConfigService, protected isConfig: boolean = true) 
  {
    this.baseUrl = isConfig ? acs.current.configApiUrl : acs.current.serviceBusApiUrl;
  }

  delete(Id: number) {
    const url = `${this.baseUrl}odata/${this.resourceName}/${Id}`;
    return this.http.delete(url);
  }

  create(value: T) {
    return this.http.post<T>(
      `${this.baseUrl}odata/${this.resourceName}/`,
      value
    );
  }

  update(dataItem: T, isNew: boolean = false) {
    if (!isNew) {
      const url = `${this.baseUrl}odata/${this.resourceName}/${dataItem.Id}`;
      return this.http.put(url, dataItem);
    } else {
      return this.create(dataItem);
    }
  }

  get(state: State, queryUrl: string) {
    let queryString = '';
    if (state) {
      queryString += toODataString(state);
    }
    if (queryUrl && queryUrl.length > 0) {
      queryString += queryUrl;
    }
    const url = `${this.baseUrl}odata/${this.resourceName}?${queryString}&$count=true`;
    return this.http.get<ODataResponse<T>>(url).pipe(
      switchMap((response) => {
        const gridResult: GridDataResult = {
          data: [...response.value],
          total: response["@odata.count"],
        };
        return of(gridResult);
      })
    );
  }

  getEntities(queryUrl: string) : Observable<ODataResponse<T>> {
    let queryString = '';
    if (queryUrl && queryUrl.length > 0) {
      queryString += '?' + queryUrl;
    }
    const url = `${this.baseUrl}odata/${this.resourceName}${queryString}`;
    return this.http.get<ODataResponse<T>>(url);
  }

  getEntity(id: number, queryUrl: string) : Observable<T> {
    let queryString = '';
    if (queryUrl && queryUrl.length > 0) {
      queryString += '?' + queryUrl;
    }
    const url = `${this.baseUrl}odata/${this.resourceName}(${id})${queryString}`;
    return this.http.get<ODataResponse<T>>(url).pipe(
      switchMap((response) => {
        return of(response.value[0]);
      })
    );
  }
}
